import { render, staticRenderFns } from "./investmentdata.vue?vue&type=template&id=613573eb&"
import script from "./investmentdata.vue?vue&type=script&lang=js&"
export * from "./investmentdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports